<script>
    import {link} from 'svelte-spa-router'
    import active from 'svelte-spa-router/active'

    import {stackIndex, activeTab } from '../../../store';
    import Icon from '../../atoms/Icon.svelte';
	import undo from '../../../../public/assets/svg/24/undo.svg';

    export let tabs = [];
    
    const handleClick = tabValue => () => ($activeTab = tabValue);

</script>

<div class="tabs">
    <div class="tabs__header">
        <ul>
        {#each tabs as tab}
            <li>
                <a class="tab__link" href="{tab.route}" on:click={handleClick(tab.value)} use:active use:link>{tab.label}</a>
            </li>
        {/each}
        <!-- {#if tabs[0]?.context === 'feed'}
            <li class="tabs__undo">
                <button class="tabs__undo__button" disabled={$stackIndex[tabs[$activeTab]?.tab] < 1} on:click={() => {if($stackIndex[tabs[$activeTab]?.tab]) $stackIndex[tabs[$activeTab]?.tab]--}}>
                    <Icon size={16} data={undo}></Icon>
                </button>
            </li>
        {/if}
        </ul> -->
    </div>
    <!-- {#each items as item}
        {#if $activeTab == item.value}
        <div class="tabs__content">
            <svelte:component this={item.component}/>
        </div>
        {/if}
    {/each} -->
</div>
<style lang="scss" src="./Tabs.scss"></style>